module.exports = __webpack_public_path__ + "static/img/pc-web-bg@t.c31713f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/premium-food-market/pc-web-bg@t.png
// module id = IErP
// module chunks = 0